// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import LanguageSwitcherController from "./language_switcher_controller"
import AttachmentsController from "./attachments_controller"
import VehicleImagesController from "./vehicle_images_controller"
import NotificationsController from "./notifications_controller"
import ReplyEditorController from "./reply_editor_controller"

application.register("language-switcher", LanguageSwitcherController)
application.register("attachments", AttachmentsController)
application.register("vehicle-images", VehicleImagesController)
application.register("notifications", NotificationsController)
application.register("reply-editor", ReplyEditorController)
